import { Autocomplete, Checkbox, TextField } from '@mui/material';

//multiSelect filter component
export const MultiSelectCheckboxFilter = ({ item, applyValue, options }) => {
  const handleChange = (event, newValue) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <Autocomplete
      className="tableChip"
      multiple
      disableCloseOnSelect
      options={options}
      value={item.value || []}
      onChange={handleChange}
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ display: 'flex', padding: '0px 2px', fontSize: '12px' }}>
          <Checkbox checked={selected} size="small" style={{ marginRight: 8, padding: '0px' }} />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Value"
          placeholder="Filter value"
          InputLabelProps={{
            shrink: true
          }}
        />
      )}
    />
  );
};

export const createMultiSelectOperator = (options) => ({
  label: 'is any of',
  value: 'multiSelect',
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || filterItem.value.length === 0) {
      return null;
    }
    return (params) => filterItem.value.includes(params.value);
  },
  InputComponent: (props) => <MultiSelectCheckboxFilter {...props} options={options} />
});

//Zone muliselect filter component
const getZoneLabel = (pct) => {
  if (pct >= 90) return 'Red';
  if (pct >= 75) return 'Orange';
  if (pct >= 50) return 'Yellow';
  return 'Green';
};

const zoneFilter = [
  { value: 'Red', label: 'Red', color: '#f44336' },
  { value: 'Orange', label: 'Orange', color: '#ff9800' },
  { value: 'Yellow', label: 'Yellow', color: '#ffeb3b' },
  { value: 'Green', label: 'Green', color: '#4caf50' }
];

const ZoneMultiSelectCheckboxInput = ({ item, applyValue, focusElementRef }) => {
  // Normalize current value into option objects
  const valueAsOptions = (Array.isArray(item.value) ? item.value : [])
    .map((v) => (typeof v === 'string' ? zoneFilter.find((o) => o.value === v) : v))
    .filter(Boolean);

  return (
    <Autocomplete
      className="tableChip"
      multiple
      disableCloseOnSelect
      options={zoneFilter}
      value={valueAsOptions}
      isOptionEqualToValue={(o, v) => o.value === v.value}
      getOptionLabel={(o) => o.label}
      onChange={(_, newVal) => applyValue({ ...item, value: newVal })}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ display: 'flex', padding: '0px 2px', fontSize: '12px' }}>
          <Checkbox size="small" checked={selected} style={{ marginRight: 8, padding: '0px' }} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={focusElementRef}
          variant="standard"
          label="Value"
          placeholder="Filter value"
          InputLabelProps={{
            shrink: true
          }}
        />
      )}
    />
  );
};

export const zoneOperator = {
  label: 'is any of',
  value: 'zoneAnyOf',
  requiresFilterValue: true,
  InputComponent: ZoneMultiSelectCheckboxInput,
  getApplyFilterFn: (item) => {
    const raw = item?.value;
    const selected = Array.isArray(raw) ? raw : raw ? [raw] : [];
    if (!selected.length) return null;

    // Compare by the plain labels: ['Red','Orange','Yellow','Green']
    const wanted = selected.map((v) => (typeof v === 'string' ? v : v.value));

    // Called with { value } for the current column
    return ({ value }) => wanted.includes(getZoneLabel(Number(value)));
  }
};
